















































































import ChoiceScorer from "@/views/ChoiceViewpointsScorer/ChoiceViewpointsScorer.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import Decisions from "@/store/modules/Decisions";
import Scoring from "@/store/modules/Scoring";
import Choices from "@/store/modules/Choices";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import CommentThreadPanel from "@/components/comments/CommentThreadPanel.vue";
import Comments from "@/store/modules/Comments";
import CommentThreadDisplay from "@/components/comments/CommentThreadDisplay.vue";
import Modelling from "@/store/modules/Modelling";
import { VIEWPOINT_API } from "@/api/ViewpointApi";

const modellingModule = getModule(Modelling)
const viewpointsModule = getModule(Viewpoints)
const decisionsModule = getModule(Decisions);
const scoringModule = getModule(Scoring);
const choicesModule = getModule(Choices);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const commentsModule = getModule(Comments)
@Component({
    components: {
        CommentThreadDisplay,
        CommentThreadPanel,
        ChoiceScorer
    },
})
export default class ScoreInput extends Vue {

    @Prop()
    private formId!: string;

    private ready = false;

    private formData: any = {};

    mounted() {
        this.init();
    }

    get loaded() {
        return this.ready;
    }

    get selectedCommentResource() {
        return commentsModule.newSelectedCommentResource
    }

    private closeComments() {
        // commentsModule.setSelectedCommentResource(null);
    }

    private async init() {
        let formData = await VIEWPOINT_API.getForm(this.formId);
        this.formData = formData;
        await decisionsModule.fetchDecisions();
        await decisionsModule.selectDecision(formData.decisionId)
        formData.viewpointIds.forEach(viewpointsModule.selectViewpoint);
        choicesModule.selectChoice(formData.choiceId)
        await workspaceOptionsModule.changeContributingFactorVisibility(false);
        await workspaceOptionsModule.changeScoreBarVisibility(formData.showBars);
        await workspaceOptionsModule.openAllExpansions();
        await commentsModule.fetchComments();

        this.ready = true;
    }

}
